/**
 * @module
 */

import {portal} from './core/portal.js';
import {publisher} from './core/publisher.js';
import {inject} from './core/service/ng.js';
import {navigator} from './core/navigator.js';
import {special} from './special/special.js';

const app = {
  navigator,
  publisher,
  portal,
  get LANG() {
    return document.body.lang;
  },
  get user() {
    return inject('user');
  },

  /**
   * @deprecated Use `portal.abbr`
   */
  get PORTAL() {
    DEBUG: console.warn('deprecated `${PORTAL}` use `${portal.abbr} plz`');
    return portal.abbr;
  },

  /**
   * @deprecated Use `user.fsk`
   */
  get FSK() {
    DEBUG: console.warn('deprecated `${FSK}` use `${user.fsk} plz`');
    return this.user.fsk;
  },
  special,
};

export {app};
